<template>
  <main class="cloud-phone-page">
    <header class="cloud-phone-header">
      <el-button text :icon="ArrowLeft" circle aria-label="返回云手机列表" @click="backToDevices" />
      <h1>{{ device.deviceName || '云手机' }}</h1>

      <el-tag :type="device.deviceStatus === 'ONLINE' ? 'success' : 'info'">
        {{ deviceLoaded ? (device.deviceStatus === 'ONLINE' ? '在线' : '离线') : '加载中' }}
      </el-tag>
    </header>

    <section class="player-layout">
      <NativeCloudPhonePlayer
        v-if="deviceLoaded && device.deviceStatus === 'ONLINE'"
        :device-id="deviceId"
        @upload-request="uploadDialogVisible = true"
      />

      <el-result
        v-else-if="deviceLoaded"
        icon="warning"
        title="云手机当前不可用"
        sub-title="请返回设备列表后刷新状态。"
      >
        <template #extra>
          <el-button type="primary" @click="backToDevices">返回列表</el-button>
        </template>
      </el-result>

      <el-skeleton v-else class="device-loading" :rows="9" animated />
    </section>

    <CloudPhoneUploadDialog
      v-model="uploadDialogVisible"
      :device-id="deviceId"
    />
  </main>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { ArrowLeft } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { useRoute, useRouter } from 'vue-router'
import NativeCloudPhonePlayer from '../components/cloudphone/NativeCloudPhonePlayer.vue'
import CloudPhoneUploadDialog from '../components/cloudphone/CloudPhoneUploadDialog.vue'
import { fetchCloudDevice } from '../api/cloudDevice'

const route = useRoute()
const router = useRouter()
const deviceId = route.params.deviceId
const device = ref({})
const deviceLoaded = ref(false)
const uploadDialogVisible = ref(false)

async function loadDevice() {
  try {
    device.value = await fetchCloudDevice(deviceId)
  } catch (error) {
    ElMessage.error(error.message || '读取云手机信息失败')
  } finally {
    deviceLoaded.value = true
  }
}

function backToDevices() {
  router.push('/devices')
}

onMounted(loadDevice)
</script>

<style scoped>
.cloud-phone-page {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  padding: calc(8px + env(safe-area-inset-top, 0px)) max(12px, env(safe-area-inset-right, 0px)) calc(8px + env(safe-area-inset-bottom, 0px)) max(12px, env(safe-area-inset-left, 0px));
  background: #080a0c;
}

.cloud-phone-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: min(1080px, 100%);
  margin: 0 auto;
}

.cloud-phone-header p,
.cloud-phone-header h1 {
  margin: 0;
}

.cloud-phone-header p {
  margin-top: 12px;
  color: #a8b5ba;
  font-size: 13px;
}

.cloud-phone-header h1 {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
  color: #ffffff;
  font-size: 20px;
}

.player-layout {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  width: min(1080px, 100%);
  min-width: 0;
  min-height: 0;
  margin: 6px auto 0;
}

.device-loading {
  width: min(520px, 100%);
  padding: 24px;
  background: #ffffff;
  border-radius: 8px;
}

.cloud-phone-header :deep(.el-button) {
  color: #d7e3e8;
}

@media (max-width: 640px) {
  .cloud-phone-header h1 {
    font-size: 18px;
  }

}
</style>
